"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getArabicAmPM = _interopRequireDefault(require("../getArabicAmPM"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Returns the arabic time. eg: ['10:30 AM'] into ['10:30 صباح`]
 * @param {*} value
 * @returns {String}
 */
function getArabicTime(value) {
  var returnValue = value.map(function (item) {
    return (0, _getArabicAmPM["default"])(item);
  });
  return returnValue;
}
var _default = exports["default"] = getArabicTime;